import { AlertTriangle } from "lucide-react";

// Warns the tech that "Not sure" items on the quote need an on-site frame check.
export function FrameCheckBadge({ count, size = "sm" }) {
  if (!count) return null;
  const cls = size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
  return (
    <span className={`inline-flex items-center gap-1 rounded-full bg-amber-100 text-amber-800 font-semibold ${cls}`}
      data-testid="frame-check-badge" title={`${count} item${count === 1 ? "" : "s"} marked "Not sure": check frames before rescreening`}>
      <AlertTriangle className={size === "xs" ? "w-3 h-3" : "w-3.5 h-3.5"} />
      Frame check needed{count > 1 ? ` (${count})` : ""}
    </span>
  );
}
